(function () {
  // --- A11y: skip-to-content link + main landmark (WCAG 2.4.1) ---
  var main = document.querySelector('section');
  if (main && !document.querySelector('.skip-link')) {
    if (!main.id) main.id = 'main-content';
    main.setAttribute('tabindex', '-1');
    main.setAttribute('role', 'main');
    var skip = document.createElement('a');
    skip.href = '#' + main.id;
    skip.className = 'skip-link';
    skip.textContent = 'İçeriğe geç';
    document.body.insertBefore(skip, document.body.firstChild);
  }

  // --- A11y: mark decorative icons hidden (all icons are decorative; interactive
  //     controls carry their own aria-label, so no icon is a sole accessible name) ---
  document.querySelectorAll('svg:not([aria-hidden])').forEach(function (s) {
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
  });

  // --- Mobile hamburger menu ---
  var header = document.querySelector('header');
  var toggle = document.querySelector('.nav-toggle');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('nav.menu a').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // --- Scroll reveal (elements already in view render immediately, no flash) ---
  var targets = document.querySelectorAll('section:not(.authority):not(.no-reveal), .authority .line, .authority .badges span, .tcard, .shop-card, .cmethod, .cform, .price-card');
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' })
    : null;

  targets.forEach(function (el, i) {
    var r = el.getBoundingClientRect();
    if (!io || r.top < window.innerHeight * 0.92) { el.classList.add('reveal', 'in'); return; }
    el.classList.add('reveal');
    el.style.transitionDelay = (Math.min(i % 6, 5) * 40) + 'ms';
    io.observe(el);
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // --- Image load fade-in (cached/already-loaded and broken images are left visible) ---
  document.querySelectorAll('img').forEach(function (img) {
    if (img.closest('.hero-art')) return;            // hero product has its own entrance
    if (img.complete && img.naturalWidth > 0) return; // already painted, no fade needed
    img.classList.add('img-load');
    var done = function () { img.classList.add('img-in'); };
    img.addEventListener('load', done);
    img.addEventListener('error', done);
  });

  // --- Subtle scroll parallax on the standalone photo blocks ---
  var plx = [].slice.call(document.querySelectorAll('.ritual-photo, .science-art, .family-art'));
  if (plx.length && !reduce) {
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      plx.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -60 || r.top > vh + 60) return;
        var prog = ((r.top + r.height / 2) - vh / 2) / vh; // ~ -0.7 .. 0.7
        el.style.setProperty('--plx', (prog * -18).toFixed(1) + 'px');
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
})();

/* Hero boxes: grab & drag them around (mouse / fine-pointer only) */
(function () {
  if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches) return;
  var boxes = [].slice.call(document.querySelectorAll('.hero-boxes .hbox'));
  boxes.forEach(function (box) {
    box._x = 0; box._y = 0;
    var apply = function () { box.style.transform = 'translate(' + box._x + 'px,' + box._y + 'px)'; };
    var freeze = function () { box.style.animation = 'none'; box.style.opacity = '1'; apply(); };
    box.addEventListener('animationend', freeze);   // free the transform once the entrance ends
    setTimeout(freeze, 3200);                        // fallback if the entrance was interrupted
    box.style.cursor = 'grab';
    var dragging = false, sx = 0, sy = 0, ox = 0, oy = 0;
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { box.setPointerCapture(e.pointerId); } catch (_) {}
      sx = e.clientX; sy = e.clientY; ox = box._x; oy = box._y;
      box.style.animation = 'none'; box.style.zIndex = '5'; box.style.cursor = 'grabbing';
      e.preventDefault();
    });
    box.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      box._x = ox + (e.clientX - sx);
      box._y = oy + (e.clientY - sy);
      apply();
    });
    var end = function () { if (!dragging) return; dragging = false; box.style.cursor = 'grab'; };
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', end);
  });
})();
